
    <!--
 * 竖版-首页
 * @LastEditTime: Sat Sep 14 2024 18:08:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_K1XQ135"  :class="[`normal`,`u_c_K1XQ135`]" ><a id="u_c_EGZF136" href="javascript:;" :class="[`normal btn-light`,`u_c_EGZF136`]" @click="u_c_EGZF136_event_8QY427($event)">{{`${ langData.infoBtn }`}}</a><div id="u_c_INJH138"  :class="[`normal`,`u_c_INJH138`]" ></div><div id="u_c_5DOV139"  v-html="compData.title" :class="[`normal`,`u_c_5DOV139`]" ></div><div id="u_c_G5KT140"  :class="[`normal`,`u_c_G5KT140`]" ><div id="u_c_7OVW141"  v-html="compData.eventTime" :class="[`normal`,`u_c_7OVW141`]" ></div></div><div id="u_c_8QKA142"  :class="[`normal`,`u_c_8QKA142`]" ><div id="u_c_IJFI143"  v-show="!pageData.isLogin" :class="[`normal login-box`,`u_c_IJFI143`]" ><div id="u_c_5076144"  :class="[`normal txt`,`u_c_5076144`]" >{{`${ langData.pleaseLogin }`}}</div><a id="u_c_9N0F146" href="javascript:;" :class="[`normal txt btn`,`u_c_9N0F146`]" @click="u_c_9N0F146_event_Q72S64($event)">{{`[${ langData.login }]`}}</a></div><div id="u_c_IC6I148"  v-show="pageData.isLogin" :class="[`normal login-box`,`u_c_IC6I148`]" ><div id="u_c_67TS149"  v-show="pageData.isBind" :class="[`normal txt btn`,`u_c_67TS149`]" >{{`${ pageData.serverName }-${ pageData.roleName }`}}</div><div id="u_c_31I8151"  :class="[`normal`,`u_c_31I8151`]" ><a id="u_c_8RVR152" href="javascript:;" v-show="!pageData.isBind" :class="[`normal txt btn `,`u_c_8RVR152`]" @click="u_c_8RVR152_event_Z75334($event)">{{`[${ langData.bindTitle }]`}}</a><a id="u_c_IJTU154" href="javascript:;" v-show="pageData.isBind && pageData.canReBind" :class="[`normal txt btn `,`u_c_IJTU154`]" @click="u_c_IJTU154_event_Z75334($event)">{{`[${ langData.changRole }]`}}</a><a id="u_c_HF2S156" href="javascript:;" :class="[`normal txt btn `,`u_c_HF2S156`]" @click="u_c_HF2S156_event_4DJR33($event)">{{`[${ langData.myPackage }]`}}</a><a id="u_c_B3AX158" href="javascript:;" :class="[`normal txt btn`,`u_c_B3AX158`]" @click="u_c_B3AX158_event_Q72S64($event)">{{`[${ langData.logout }]`}}</a></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"eventTime":`活动时间：2023年2月28日 ～2023年3月3日23:59`,"title":`2周年庆典`},"zh-TW":{"eventTime":`活動時間：2024年9月16日 0:00 -2024年9月29日 23:59`,"title":`中秋贈豪禮`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})

const curPlatform = pagePlatform;

const canClickChange = ref(true);
;
      // 活动规则的click事件
      const u_c_EGZF136_event_8QY427= async (e)=>{
        try {pageData.infoPopupState = true;} catch (error) {console.log(error)}
      };
      // 登入按钮的click事件
      const u_c_9N0F146_event_Q72S64= async (e)=>{
        try {checkIsLogin()} catch (error) {console.log(error)}
      };
      // 绑定按钮的click事件
      const u_c_8RVR152_event_Z75334= async (e)=>{
        try {if (!checkIsLogin()) return
pageData.bindPopupState = true;} catch (error) {console.log(error)}
      };
      // 解绑按钮的click事件
      const u_c_IJTU154_event_Z75334= async (e)=>{
        try {if (!canClickChange.value) return;

canClickChange.value = false;

let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'resetUserBind'))
canClickChange.value = true;

if (res.result != 1) {
  showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  return;
}

pageData.isBind = false;
pageData.roleName = "";
pageData.serverName = "";} catch (error) {console.log(error)}
      };
      // 背包按钮的click事件
      const u_c_HF2S156_event_4DJR33= async (e)=>{
        try {pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 登出按钮的click事件
      const u_c_B3AX158_event_Q72S64= async (e)=>{
        try {let res = await request.getJSON(utils.getLogoutApi(pagePlatform))
if (res.result == 1) {
  window.location.reload()
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.07rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208725-22.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.default{
.u_c_EGZF136.normal{
position:absolute;
width:2.67rem;
height:0.87rem;
top:0.40rem;
right:6.87rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208670-70.jpeg);
display:flex;
align-items:center;
font-size:0.29rem;
color:#f7f7f7;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.default{
.u_c_INJH138.normal{
position:absolute;
width:1.81rem;
height:1.64rem;
top:0.05rem;
right:0.05rem;
background:no-repeat center;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715369121381.png);
background-size:contain;

}
}.default{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:5.29rem;
left:0.16rem;
font-size:1.08rem;
color:#fedb2a;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.default{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417498958-25.png);
margin:auto;
margin-top:7.20rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.default{
.u_c_7OVW141.normal{
position:relative;

}
}.default{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.default{
.u_c_IJFI143.normal{
position:relative;

}
}.default{
.u_c_5076144.normal{
position:relative;

}
}.default{
.u_c_9N0F146.normal{
position:relative;

}
}.default{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.default{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_8RVR152.normal{
position:relative;

}
}.default{
.u_c_IJTU154.normal{
position:relative;

}
}.default{
.u_c_HF2S156.normal{
position:relative;

}
}.default{
.u_c_B3AX158.normal{
position:relative;

}
}.zh-TW{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.07rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208725-22.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.zh-TW{
.u_c_EGZF136.normal{
position:absolute;
width:2.67rem;
height:0.87rem;
top:0.40rem;
right:6.87rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208670-70.jpeg);
display:flex;
align-items:center;
font-size:0.29rem;
color:#f7f7f7;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.zh-TW{
.u_c_INJH138.normal{
position:absolute;
width:1.81rem;
height:1.64rem;
top:0.05rem;
right:0.05rem;
background:no-repeat center;
background-size:contain;

}
}.zh-TW{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:5.29rem;
left:0.16rem;
font-size:1.08rem;
color:#fedb2a;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.zh-TW{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417498958-25.png);
margin:auto;
margin-top:7.20rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.zh-TW{
.u_c_7OVW141.normal{
position:relative;

}
}.zh-TW{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.zh-TW{
.u_c_IJFI143.normal{
position:relative;

}
}.zh-TW{
.u_c_5076144.normal{
position:relative;

}
}.zh-TW{
.u_c_9N0F146.normal{
position:relative;

}
}.zh-TW{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.zh-TW{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.zh-TW{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.zh-TW{
.u_c_8RVR152.normal{
position:relative;

}
}.zh-TW{
.u_c_IJTU154.normal{
position:relative;

}
}.zh-TW{
.u_c_HF2S156.normal{
position:relative;

}
}.zh-TW{
.u_c_B3AX158.normal{
position:relative;

}
}
</style>
